import { Skeleton } from "primereact/skeleton"

export const Skeletons = () => {
    return (
        <div className="flex flex-column justify-content-between w-full lg:pr-6 lg:pl-5">
            <div className="grid">
                <div className="col-12 md:col-6 flex flex-column justify-content-between">
                    <div className="mb-5">
                        <Skeleton width="12rem" height="2rem"></Skeleton>
                        <Skeleton className="my-5" width="17rem" height="1rem"></Skeleton>
                        <Skeleton className="my-5" width="8rem" height="1rem"></Skeleton>
                    </div>

                    <div className="label justify-content-center md:justify-content-start w-full flex">
                        <div>
                            <Skeleton shape="circle" size="3rem" className="mr-2"></Skeleton>
                        </div>

                        <div>
                            <Skeleton className="mb-1" width="14rem" height="1rem"></Skeleton>
                            <Skeleton width="13rem" height="1rem"></Skeleton>
                        </div>
                    </div>
                </div>

                <div className="col-12 md:col-6 lg:pl-8">
                    <Skeleton width="15rem" height="1rem"></Skeleton>
                    <Skeleton className="my-5" height="3rem"></Skeleton>
                    <div>
                        <Skeleton width="4rem" height="1rem"></Skeleton>
                        <Skeleton className="mt-1" width="8rem" height="2rem"></Skeleton>
                        <Skeleton className="mt-5 mb-1" height="3rem"></Skeleton>
                        <Skeleton width="15rem" height="1rem"></Skeleton>
                    </div>
                </div>
            </div>
        </div>
    )
}